import { useTranslation } from 'react-i18next';

export default function NoArticlesMessage({
    criticalSize,
    nonCriticalSize,
}: {
    criticalSize: number;
    nonCriticalSize: number;
}) {
    const { t } = useTranslation('common');
    if (criticalSize > 0 || nonCriticalSize > 0) {
        return null;
    }
    return (
        <div className="col-span-full text-center py-12">
            <p className="text-lg text-muted-foreground">{t('noArticlesFound')}</p>
        </div>
    );
}
